import User from "../models/User";

const fetchAppSheetOptionsForClient = async ({queryKey, signal}) => {

    let user = TB.auth().user();
    if (!user || !user.canManageClients()) {
        throw new Error('Unauthorized')
    }
    const appSheetRequest = TB.request(
        TB.api_endpoint(`/api/appsheet/clients/${user.clientOrg?.()?.id}/options`)
    );

    let response = await appSheetRequest.get({signal}).catch(e => {
        throw new Error(e.message)
    })

    if (!TB.has(response, 'success.data.options')) {
        throw new Error('Something Went Wrong')
    }

    return response.success.data
}
const fetchAppSheetOptionsForProject = async ({queryKey, signal}) => {
    let params = queryKey[1] || {}
    let user = TB.auth().user();
    if (!user || !user.canManageClients() || !params?.projectId) {
        throw new Error('Unauthorized')
    }
    const appSheetRequest = TB.request(
        TB.api_endpoint(`/api/appsheet/clients/${user.clientOrg?.()?.id}/projects/${params?.projectId}/options`)
    );

    let response = await appSheetRequest.get({signal}).catch(e => {
        throw new Error(e.message)
    })

    if (!TB.has(response, 'success.data.options')) {
        throw new Error('Something Went Wrong')
    }

    return response.success.data
}

const fetchForTalentAsManager = async ({queryKey, signal}) => {
    let {talentId} = queryKey[1] || {}

    return User.fetchForTalentAsManager(talentId)
}

const searchTalentForMessaging = async ({queryKey, signal}) => {
    const params = queryKey[1] || {};

    let formattedParams = {};
    for (let [key, value] of Object.entries(params)) {
        if (TB.isArray(value)) {
            if (!value.length) continue;
            value = value.join(',');
        }
        formattedParams[key] = value;
    }

    const request = TB.request(
        TB.api_endpoint('/api/users/talent'),
        formattedParams
    );

    const response = await request.get({signal}).catch(e => {
        throw new Error(e.message || 'Request failed')
    });

    if (!TB.has(response, 'success.data.users')) {
        throw new Error('Something Went Wrong');
    }

    return response.success.data;
}
const fetchTalentUserStatsForTalentManager = async ({queryKey, signal}) => {

    let request = TB.request(TB.api_endpoint('/api/users/talent/stats'));

    let response = await request.get({signal}).catch(console.warn);

    if (!TB.has(response, 'success.data.stats')) {
        throw new Error('Something Went Wrong');
    }
    return response.success.data.stats
}


const fetchAppSheetOptionsForProjectPosition = async ({queryKey, signal}) => {
    let params = queryKey[1] || {}
    let user = TB.auth().user();
    if (!user || !user.canManageClients() || !params?.projectId || !params?.positionId) {
        throw new Error('Unauthorized')
    }
    const appSheetRequest = TB.request(
        TB.api_endpoint(`/api/appsheet/clients/${user.clientOrg?.()?.id}/projects/${params?.projectId}/positions/${params?.positionId}/options`)
    );

    let response = await appSheetRequest.get({signal}).catch(e => {
        throw new Error(e.message)
    })

    if (!TB.has(response, 'success.data.options')) {
        throw new Error('Something Went Wrong')
    }

    return response.success.data
}

const fetchNotificationParams = async ({signal}) => {
    const request = TB.request(TB.api_endpoint('/api/system-notifications/notification-params'))

    const response = await request.get({signal}).catch(e => {
        throw new Error(e.message)
    })

    if (!TB.has(response, 'success.data.notification_senders')) {
        throw new Error('Something Went Wrong')
    }

    // Returns { notification_senders: [...], us_states: { abbr: name, ... } }
    return response.success.data
}

const fetchSystemNotifications = async ({queryKey, signal}) => {
    let {page} = queryKey[1] || {}
    const url = page && page > 1
        ? `/api/system-notifications?page=${page}`
        : '/api/system-notifications'
    const request = TB.request(TB.api_endpoint(url));

    let response = await request.get({signal}).catch(e => {
        throw new Error(e.message)
    })

    if (!TB.has(response, 'success.data')) {
        throw new Error('Something Went Wrong')
    }

    return response.success.data
}

const fetchSystemNotification = async ({queryKey, signal}) => {
    let {messageId} = queryKey[1] || {}

    const request = TB.request(TB.api_endpoint(`/api/system-notifications/${messageId}`));

    let response = await request.get({signal}).catch(e => {
        throw new Error(e.message)
    })

    if (!TB.has(response, 'success.data.notification')) {
        throw new Error('Something Went Wrong')
    }

    return response.success.data.notification
}

const fetchClients = async ({queryKey, signal}) => {
    const params = queryKey[1] || {};

    const request = TB.request(
        TB.api_endpoint('/api/clients'),
        params
    );

    const response = await request.get({signal}).catch(e => {
        throw new Error(e.message || 'Request failed')
    });

    if (!TB.has(response, 'success.data')) {
        throw new Error('Something Went Wrong');
    }

    return response.success.data;
}

const fetchProjectPositions = async ({queryKey, signal}) => {
    const params = queryKey[1] || {};

    const request = TB.request(
        TB.api_endpoint('/api/project-positions'),
        params
    );

    const response = await request.get({signal}).catch(e => {
        throw new Error(e.message || 'Request failed')
    });

    if (!TB.has(response, 'success.data')) {
        throw new Error('Something Went Wrong');
    }

    return response.success.data;
}

export {
    fetchAppSheetOptionsForClient,
    fetchAppSheetOptionsForProject,
    fetchAppSheetOptionsForProjectPosition,
    fetchForTalentAsManager,
    fetchTalentUserStatsForTalentManager,
    fetchNotificationParams,
    fetchSystemNotifications,
    fetchSystemNotification,
    searchTalentForMessaging,
    fetchClients,
    fetchProjectPositions,
}